<template>
    <div class="manual-reconcile-bar" v-if="selectedStatementCount > 0">
        <div class="manual-reconcile-bar-batch-info">
            <span>{{ selectedStatementCountLabel }}</span>
        </div>
        <div class="manual-reconcile-bar-divider"></div>
        <div class="manual-reconcile-bar-actions">
            <Button _key="btnRemoveBatch" title="Remover Selecionados" size="medium" type="danger"
                :clicked="onRemoveBatch" />
            <Button _key="btnManualCancel" title="Cancelar" size="medium" type="edit" :clicked="onCancel" />
        </div>
    </div>
</template>
<script>

import Button from "@/ui/forms/Button";

export default {
    name: "ManualReconcileBar",
    components: { Button },
    props: {
        selectedStatementCount: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        selectedStatementCountLabel() {
            return this.selectedStatementCount == 1
                ? '1 item do extrato selecionado'
                : this.selectedStatementCount + ' itens do extrato selecionados';
        },
    },
    methods: {
        onRemoveBatch() {
            this.$emit('remove-batch');
        },
        onCancel() {
            this.$emit('cancel');
        },
    },
};
</script>
<style scoped>
.manual-reconcile-bar {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 24px;
    background: var(--bg-base);
    border: 1px solid var(--border-color);
    color: var(--text-primary);
    padding: 12px 16px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: var(--shadow-lg);
    z-index: 50;
    max-width: 92vw;
}

.manual-reconcile-bar-batch-info {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
    padding: 0 6px;
}

.manual-reconcile-bar-divider {
    width: 1px;
    align-self: stretch;
    background: var(--border-color);
}

.manual-reconcile-bar-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}
</style>
